<template>
    <div class="results-wrapper mt-3" v-if="certified.length >0">
        <h4  v-if="certified.length > 0 && isBrand == 'true'"> Where to buy our products:</h4>

        <swiper class="swiper" :options="swiperOption" v-if="isBrand ==='true'">

            <swiper-slide v-for="slide in certified" :key="slide.bizID">
                <a v-bind:href="slide.url">
                    <img :src="slide.logo" alt="business-logo"
                         class="img-fluid img-size">
                    <div class="pt-2">
                        <tr>
                            <td class="truncate">{{ slide.name}}</td>
                        </tr>
                        <tr>
                            <td class="truncate">{{slide.location}}</td>
                        </tr>
                    </div>
                </a>
            </swiper-slide>
        </swiper>
        <swiper class="swiper" :options="swiperOption" v-else-if="isBrand === 'false'">
            <swiper-slide v-for="slide in certified" :key="slide.bizID" >
                <a v-bind:href="slide.url">
                    <img :src="slide.logo" alt="business-logo"
                         class="img-fluid img-crop" >
                    <img :src="certifiedBadge" class="img-fluid img-auth pt-4 pl-lg-1">
                </a>
            </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" :style=" isBrand === 'false' ? 'top:70px': 'top:120px'" slot="button-prev"></div>
        <div class="swiper-button-next" :style=" isBrand === 'false' ? 'top:70px': 'top:120px'" slot="button-next"></div>

    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
    name: 'CertifiedReseller',
    props:{
        "certified": Array,
        "certifiedBadge":String,
        "isBrand":String,
    },
    title: 'Pagination',
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            swiperOption: {
                breakpoints: {
                    992: { slidesPerView: 6, spaceBetween: 20, slidesPerGroup:5 },
                    900: { slidesPerView: 4.75, spaceBetween: 15, slidesPerGroup: 3 },
                    775: { slidesPerView: 5, spaceBetween: 15, slidesPerGroup: 3 },
                    725: { slidesPerView: 4.25, spaceBetween: 15},
                    600: { slidesPerView: 4.2, spaceBetween: 15},
                    500: { slidesPerView: 3.2, spaceBetween: 10},
                    350: { slidesPerView: 3.2,spaceBetween: 5},
                    0: { slidesPerView: 2.5, spaceBetween: 5 }
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/_variables.scss";
.swiper-slide {
    width: 12em;
    height: 6rem;
}
td{
    color: black;
}
p{
    width: 8em;
    font-size: 10pt;
    color: black;
    margin-top: 0.8em;
    line-height: 0.1em;
}
.img-size {
    max-height: 7em;
    max-width: 7em;
}
.img-crop {
    max-height: 5em;
    max-width: 5em;
    position: relative;
    top: 0.8em;
    left: 0.8em;
    object-fit: cover;
    border-radius: 50%;

}
.img-auth {
    max-height: 8em;
    max-width: 8em;
    top:-1.8em;
    left: 0;
    position: absolute;
    z-index: 6;
}
.truncate {
    max-width: 6em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
@media screen and (min-width: 500px) {
    .img-crop {
        max-height: 4em;
        max-width: 4em;
        position: relative;
        top: 1em;
        left: 1.2em;
        object-fit: cover;
        border-radius: 50%;

    }
    .img-auth {
        max-height: 8em;
        max-width: 8em;
        position: absolute;
        z-index: 6;
    }
}

@media screen and (min-width: 1024px) {
    .img-crop {
        max-height: 4em;
        max-width: 4em;
        position: relative;
        top: 1em;
        left: 1.45em;
        object-fit: cover;
        border-radius: 50%;

    }
    .truncate {
        max-width: 8em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .swiper-button-prev {
        left: -40px;
        margin-top: -3rem;
    }

    .swiper-button-next {
        right: -45px;
        margin-top: -3rem;
    }
}
.results-wrapper {
    position: relative;
}

.swiper-button-prev, .swiper-button-next {
    top: 120px;
    color: grey;
    display: none;
    @media only screen and (min-width: 776px){
        display: block;

    }

}
@media only screen and (min-width: 776px) {
    .swiper-button-prev {
        margin-top: -3rem;
    }

    .swiper-button-next {
        margin-top: -3rem;
    }
    .swiper{
        margin-left: 2.2rem;
    }

}

</style>
